// extracted by mini-css-extract-plugin
export const hero = "HomeView-module--hero--gsEo2";
export const heroImage = "HomeView-module--heroImage--3wr15";